/**
 * Ensure that a string is shorter than a specified limit; if the string is already shorter, returns
 * the string. If it is longer, returns the string truncated with an ellipsis
 *
 * @param  {String} text - the string to be truncated
 * @param  {Number} limit - the maximum number of characters of the string
 *
 * @return {String} Truncated string of length <= limit
 */
export default function truncateText(text, limit) {
    return text.length >= limit ? `${text.substring(0, (limit - 3)).trim()}...` : text;
}
